import { render, staticRenderFns } from "./CommonDeleteDialog.vue?vue&type=template&id=4b9b8259&scoped=true&v-loading=loading&"
import script from "./CommonDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./CommonDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9b8259",
  null
  
)

export default component.exports